<div class="simple-dialog">
  <div mat-dialog-title class="dialog-header">
    <div class="dialog-title">
      <mat-icon>description</mat-icon>
      <h2>{{ (data.isEditingNew ? 'ppwr.docProfiles.dialog.addTitle' : 'ppwr.docProfiles.dialog.editTitle') | transloco }}</h2>
    </div>

    <button mat-icon-button type="button" [attr.aria-label]="'common.buttons.close' | transloco" (click)="closeDialog()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-dialog-content class="dialog-content">
    <p class="dialog-description">{{ 'ppwr.docProfiles.dialog.description' | transloco }}</p>

    <mat-form-field appearance="outline" class="full-width" subscriptSizing="dynamic">
      <mat-label>{{ 'ppwr.docProfiles.dialog.nameLabel' | transloco }}</mat-label>
      <input matInput [formControl]="nameControl" />
      <mat-error *ngIf="nameControl.hasError('required')">{{ 'ppwr.docProfiles.dialog.nameRequired' | transloco }}</mat-error>
      <mat-error *ngIf="nameControl.hasError('duplicateName')">{{ 'ppwr.docProfiles.dialog.nameDuplicate' | transloco }}</mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline" class="full-width" subscriptSizing="dynamic">
      <mat-label>{{ 'ppwr.evidenceFilterLabel' | transloco }}</mat-label>
      <mat-select [formControl]="evidenceTypeControl" multiple>
        <mat-option *ngFor="let evidenceType of data.evidenceTypes" [value]="evidenceType.id">{{ evidenceType.name }}</mat-option>
      </mat-select>
    </mat-form-field>

    <div class="field-search-row">
      <mat-form-field appearance="outline" class="field-search" subscriptSizing="dynamic">
        <mat-label>{{ 'ppwr.docProfiles.dialog.fieldSearchLabel' | transloco }}</mat-label>
        <input matInput [formControl]="searchControl" [placeholder]="'ppwr.docProfiles.dialog.fieldSearchPlaceholder' | transloco" />
        <mat-icon matSuffix>search</mat-icon>
      </mat-form-field>
    </div>

    <mat-tab-group>
      <mat-tab [label]="'ppwr.docProfiles.dialog.systemTab' | transloco">
        <div class="field-tab-content">
          <ng-container *ngIf="data.availableSystemCustomFields.length; else noSystemCustomFields">
            <mat-expansion-panel
              *ngFor="let section of sections"
              [expanded]="isSectionExpanded('system', section)"
              (opened)="onSectionExpandedChange('system', section, true)"
              (closed)="onSectionExpandedChange('system', section, false)">
              <mat-expansion-panel-header>
                <span [innerHTML]="('ppwr.docProfiles.dialog.sectionLabel' + section) | transloco"></span>
              </mat-expansion-panel-header>
              <div class="custom-field-list">
                <mat-checkbox *ngFor="let field of filteredSystemFields()" [checked]="isSystemFieldSelected(section, field.id)" (change)="toggleSystemField(section, field.id)">
                  {{ field.name }}
                </mat-checkbox>
              </div>
            </mat-expansion-panel>
          </ng-container>
          <ng-template #noSystemCustomFields>
            <p class="empty-text">{{ 'ppwr.docProfiles.dialog.noCustomFields' | transloco }}</p>
          </ng-template>
        </div>
      </mat-tab>

      <mat-tab [label]="'ppwr.docProfiles.dialog.unitTab' | transloco">
        <div class="field-tab-content">
          <ng-container *ngIf="data.availableUnitCustomFields.length; else noUnitCustomFields">
            <mat-expansion-panel
              *ngFor="let section of sections"
              [expanded]="isSectionExpanded('unit', section)"
              (opened)="onSectionExpandedChange('unit', section, true)"
              (closed)="onSectionExpandedChange('unit', section, false)">
              <mat-expansion-panel-header>
                <span [innerHTML]="('ppwr.docProfiles.dialog.sectionLabel' + section) | transloco"></span>
              </mat-expansion-panel-header>
              <div class="custom-field-list">
                <mat-checkbox *ngFor="let field of filteredUnitFields()" [checked]="isUnitFieldSelected(section, field.id)" (change)="toggleUnitField(section, field.id)">
                  {{ field.name }}
                </mat-checkbox>
              </div>
            </mat-expansion-panel>
          </ng-container>
          <ng-template #noUnitCustomFields>
            <p class="empty-text">{{ 'ppwr.docProfiles.dialog.noCustomFields' | transloco }}</p>
          </ng-template>
        </div>
      </mat-tab>
    </mat-tab-group>
  </mat-dialog-content>

  <mat-dialog-actions class="dialog-actions">
    <button mat-button type="button" (click)="closeDialog()">
      {{ 'common.buttons.cancel' | transloco }}
    </button>
    <button mat-raised-button color="primary" type="button" (click)="save()">
      {{ 'common.buttons.save' | transloco }}
    </button>
  </mat-dialog-actions>
</div>
